module.exports = __webpack_public_path__ + "img/red_030.660a241b.png";